export default "__VITE_ASSET__BTX6wAV2__"